module.exports = __webpack_public_path__ + "img/image (22).275ac974.jpg";